// 80 Metrics social profiles — verified from Matthew's current email
// signature (1 Nov 2026). Compact accessible icon row; external profiles
// only, no feeds, widgets or tracking scripts.
const LinkedInIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" focusable="false">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.125 2.062 2.062 0 0 1 0 4.125zM7.119 20.452H3.554V9h3.565v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z" />
  </svg>
);

const InstagramIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" focusable="false">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
  </svg>
);

const FacebookIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" focusable="false">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

export const SOCIAL_LINKS = [
  { key: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/80metrics/", Icon: LinkedInIcon },
  { key: "instagram", label: "Instagram", href: "https://www.instagram.com/80metricsproperty/", Icon: InstagramIcon },
  { key: "facebook", label: "Facebook", href: "https://www.facebook.com/80metrics/", Icon: FacebookIcon },
];

export const SocialLinks = ({ dark = false, className = "", testidPrefix = "social" }) => (
  <ul className={`flex items-center gap-2 ${className}`} data-testid={`${testidPrefix}-links`}>
    {SOCIAL_LINKS.map(({ key, label, href, Icon }) => (
      <li key={key}>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`80 Metrics on ${label}`}
          data-testid={`${testidPrefix}-${key}`}
          className={`inline-flex h-11 w-11 items-center justify-center rounded-md border transition-[color,border-color,background-color] duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 ${
            dark
              ? "border-white/15 text-ivory/70 hover:text-goldlight hover:border-goldlight/60 focus-visible:ring-offset-charcoal"
              : "border-charcoal/20 text-charcoal/70 hover:text-golddark hover:border-gold/60 focus-visible:ring-offset-white"
          }`}
        >
          <Icon className="h-4 w-4" />
        </a>
      </li>
    ))}
  </ul>
);
